export class Dimensions
{
    marginTop?: number = 0;
    marginRight?: number = 0;
    marginBottom?: number = 0;
    marginLeft?: number = 0;
    height?: number = 0;
    width?: number = 0;
    boundedHeight?: number = 0;
    boundedWidth?: number = 0;
}
